module.exports = __webpack_public_path__ + "static/media/insure_pingan.adcb9ad3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/insure_pingan.png
// module id = 2703
// module chunks = 2